import { Trans, useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';
import { StyledMaxAttemptsMessage } from './MaxAttemptsMessage.styled';
import { KccButton } from 'lib/components/KccButton/KccButton';
import { useServiceRequestContext } from 'app/modules/service/context/ServiceContext';
import { kccThemeConstants } from 'config/theme/kccTheme/kccTheme';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

export const MaxAttemptsMessage = (): JSX.Element => {
  const { t } = useTranslation();
  const { handleServiceBack } = useServiceRequestContext();

  return (
    <StyledMaxAttemptsMessage
      message={t('serviceRequestPage.verification.accountTemporarilyLocked')}
      banner
      showIcon
      icon={<SvgIcon name="warningCritical" className="error-icon" />}
      description={
        <Flex vertical gap={kccThemeConstants.SPACING.SM} justify="space-between">
          <Typography.Text style={{ margin: 0, fontWeight: kccThemeConstants.TYPOGRAPHY.FONT_WEIGHT.REGULAR }}>
            <Trans i18nKey="serviceRequestPage.verification.accountTemporarilyLockedDescription" />
          </Typography.Text>

          <div style={{ alignSelf: 'flex-start' }}>
            <KccButton type="secondary" size="small" onClick={handleServiceBack}>
              <strong>{t('serviceRequestPage.verification.updateEmail')}</strong>
            </KccButton>
          </div>
        </Flex>
      }
      type="error"
    />
  );
};
